import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import parse, { domToReact, Element } from 'html-react-parser';
import DOMPurify from 'dompurify';
import Modal from '@amzn/meridian/modal';
import { ReportActionSource, } from '@amzn/handshake-painter-typescript-client/v1';
import { InfoIconButton } from 'src/common/buttons/infoIconButton';
import { usePageContext } from 'src/hooks';
import { ExternalLink } from 'src/common/externalLink';
import { RioText } from 'src/common/styled/StyledComponets';
import { RetailRoutes, useRetailRedirectUrls } from 'src/utils/links';
export const PricePopoverModal = ({ price }) => {
    const [isPriceModalOpen, setPriceModalOpen] = useState(false);
    const { bundle } = usePageContext();
    const redirectUrls = useRetailRedirectUrls([RetailRoutes.REFERENCE_PRICE_AND_SAVINGS]);
    if (!(price === null || price === void 0 ? void 0 : price.popoverContent))
        return null;
    const sanitizedPopoverContent = DOMPurify.sanitize(price.popoverContent, {
        ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'span', 'p', 'br', 'a'],
        ALLOWED_ATTR: ['href', 'target', 'rel'],
    });
    // Route in-popover links through the SMA off-ramp (OPEN_EXTERNAL_LINK) via ExternalLink
    const options = {
        replace: (domNode) => {
            if (domNode instanceof Element && domNode.name === 'a') {
                return (_jsx(ExternalLink, { href: redirectUrls.REFERENCE_PRICE_AND_SAVINGS, id: "reference-price-more-info-link", source: ReportActionSource.ProductDetailPage, children: domToReact(domNode.children, options) }));
            }
            return undefined;
        },
    };
    return (_jsxs(React.Fragment, { children: ["\u00A0", _jsx(InfoIconButton, { onClick: () => setPriceModalOpen(!isPriceModalOpen), ariaLabel: bundle.getMessage('referencePriceInfoButton'), dataTestId: "reference-price-more-info-button", iconSize: 12 }), _jsx(Modal, { open: isPriceModalOpen, onClose: () => setPriceModalOpen(false), "data-testid": "reference-price-popoverContent-modal", title: _jsx("span", { "data-testid": "reference-price-popover-header", children: bundle.getMessage('referencePriceInfoButton') }), fullscreenBreakpoint: 0, width: 320, children: _jsx(RioText, { "data-testid": "reference-price-popoverContent", children: parse(sanitizedPopoverContent, options) }) })] }));
};
